import React from 'react';
import cx from 'classnames';
import {FieldValues, useController} from 'react-hook-form';
import MenuItem, {MenuItemProps} from '@material-ui/core/MenuItem';
import MuiTextField, {TextFieldProps} from '@material-ui/core/TextField';
import {makeStyles} from '@material-ui/core';
import {UseControllerProps} from './types';

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(2, 0)
    },
    header: {
        marginBottom: theme.spacing(2)
    },
    menuItem: {
        color: theme.palette.text.secondary
    }
}));

export interface SelectProps<FormValues extends FieldValues>
    extends UseControllerProps<TextFieldProps, FormValues> {
    header?: string | React.ReactNode | HTMLElement;
    options?: MenuItemProps[];
}

function Select<FormValues>({
    name,
    rules,
    control,
    defaultValue = '',
    shouldUnregister = true,
    header,
    options = [],
    children,
    required,
    variant,
    ...textFieldProps
}: React.PropsWithChildren<SelectProps<FormValues>>) {
    const styles = useStyles();
    const controller = useController({control, name, rules, defaultValue, shouldUnregister});

    const {
        field,
        fieldState: {invalid, error}
    } = controller;

    const {className, ...restTextFieldProps} = textFieldProps || {};
    const textFieldClasses = cx(styles.root, className);

    return (
        <MuiTextField
            {...restTextFieldProps}
            {...field}
            select
            className={textFieldClasses}
            variant={variant}
            required={required}
            error={invalid}
            helperText={error && error.message}>
            {options.map(({children, button, ...option}, i) => {
                return (
                    <MenuItem key={i} className={styles.menuItem} {...option}>
                        {children}
                    </MenuItem>
                );
            })}
        </MuiTextField>
    );
}

export default Select;
